class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.toast       = document.getElementById('cart-notification');
    this.header      = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.reposition  = this.positionUnderCartIcon.bind(this);

  }

  

  positionUnderCartIcon() {
    const MOBILE_BP = 640;
    if (window.innerWidth < MOBILE_BP) {
      this.toast.style.position = 'fixed';
      return;
    }
    const anchor = document.getElementById('cart-icon-bubble');
    if (!anchor) return;
    this.toast.style.position = 'fixed';
    // you can add left/top styles here if needed
  }

  

  open() {
    // 2) Position
    this.positionUnderCartIcon();
    window.addEventListener('resize', this.reposition);
    window.addEventListener('scroll', this.reposition, { passive: true });

    // 3) Auto-close timer
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.close(), 3000);

    // 4) Show
    this.toast.classList.add('animate', 'active');

    setTimeout(() => this.toast.classList.remove('active'), 2000);
    setTimeout(() => this.toast.classList.remove('animate'), 2000);
  }



  renderContents(itemCount, isError = false) {
    if (isError) {
      this.toast.classList.add('error');
      this.toast.querySelector('.cart-notification__text').textContent =
        'Not enough stock available';
    } else {
      this.toast.classList.remove('error');
      this.toast.querySelector('.cart-notification__text').textContent =
      this.toast.dataset.successText || 'Product added to cart';
      updateCartBubble(itemCount);
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  
}

customElements.define('cart-notification', CartNotification);




function updateCartBubble(count) {
  document.querySelectorAll('#cart-icon-bubble').forEach((link) => {
  const countEl = link.querySelector('.cart-count');


  const currentCount = countEl
    ? parseInt(countEl.textContent.replace(/\D/g, ''), 10) || 0
    : 0;

  const newCount = currentCount + 1;

  // 4) Write it back into the DOM
  if (countEl) countEl.textContent = newCount;


    // 3. Update the number
    if (countEl) {
      countEl.textContent = newCount;
    }
    
  });
}



